import {
  Box, Grid
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useStyles } from './style';

import { dateFormat } from '../../../utils/dateFormat';
import { ageCalculation } from '../../../utils/generalFunc';

export const ProfileInfoHeader = () => {
  const classes = useStyles();
  const personPhoto = useSelector((state) => state.camera?.image);
  const profile = useSelector((state) => state.profile.profilInfo);
  const BirthDate = dateFormat(profile.Birthday);
  const getAge = ageCalculation(profile.Birthday);
  const personPhotoRendering = personPhoto.split('base64,')[1] !== 'null' ? personPhoto : 'assets/images/person_black.svg';

  return (
    <Grid container rowSpacing={{ xs: 1, sm: 1, md: 1 }} pb={{ xs: 3, md: 3 }} px={{ xs: 2 }} justifyContent="space-between" alignItems="center">
      <Grid item xs={6} sm={5} md={4}>
        <Box component="img" src={personPhotoRendering} className={personPhoto ? classes.personImage : classes.withoutPersonImage} />
      </Grid>
      <Grid item xs={6} sm={5} md={4}>
        <Box textAlign="right">
          <Box component="span" fontSize={27}>
            {profile.First}
            <Box component="span" fontSize={27} fontWeight={500}> {profile.Last}</Box>
          </Box>
        </Box>
        <Box textAlign="right">
          <Box fontSize={18} fontWeight={500}>{BirthDate}</Box>
          <Box fontSize={14} fontWeight={500}>(Age {getAge})</Box>
        </Box>
      </Grid>
    </Grid>
  );
};
